// Configuración de la API
export const API_URL = 'https://api.rastros.cl/api';
export const AUTH_URL = `${API_URL}/auth/local`;

// URLs para la página de login por idioma
export const LOGIN_PAGE_URLS = {
  'es-CL': 'https://api.rastros.cl/api/login-page?populate=*&locale=es-CL',
  'en': 'https://api.rastros.cl/api/login-page?populate=*&locale=en',
  'es': 'https://api.rastros.cl/api/login-page?populate=*&locale=es-CL', // Assuming 'es' also points to es-CL for now
};

export const MESSAGE_ERROR_AUTH = 'Credenciales inválidas';
export const DEFAULT_LOCALE = 'es-CL';
export const REQUEST_TIMEOUT = 30000;